<template>
    <div class="buttonTimer">
        <s-button 
            @onclick="setTimer"
            :label="delay == null ? timerTournoi + 'mn' : delay"
            icon=""
            :afterIcon="icon"
            :theme="theme + color"
        />
      
    </div>
</template>
<style scoped>
    .buttonTimer {
        display: inline-block;
        float: left;
        margin-right: 1px;
    }
</style>
<script>
import firebase from 'firebase'
import firebase_api from '@/firebase/firebase_api'
 export default ({
        props: ["equipe", "tournoi", "club", "partie", "nav"], 
        data() {
            return {
                delay: null,
                deltaTimeStamp: this.$store.getters.getDeltaTimeStamp,
                icon: 'clock',
                theme: '',
                color: '',
                timeOut: null,
                delayReal: null
            }
        },
        computed : {
            timerTournoi: {
                get() {
                    var delay = null;
                    if (typeof(this.tournoi)!="undefined")
                            if (typeof(this.tournoi.timer)!="undefined") {
                                if (this.tournoi.timer.active)
                                    delay = this.tournoi.timer.delay;
                            }
                    return delay;
                }
            },
            timerState: {
                get() {
                    var state="";
                   
                    if (typeof(this.equipe)!="undefined")
                            if (typeof(this.equipe.timer)!="undefined")
                                state = this.equipe.timer.state ;
                    return state;
                }
            },
            delayEquipe: {
                get() {
                    if (typeof(this.equipe)!="undefined")
                        if (typeof(this.equipe.timer)!="undefined")
                            return this.equipe.timer.ts;
                }
            },
            delayRealEquipe: {
                get() {
                    if (typeof(this.equipe)!="undefined")
                        if (typeof(this.equipe.timer)!="undefined")
                            return this.equipe.timer.delay;
                }
            }
        },
        watch: {
            timerTournoi: {
                handler(val) {
                    this.delayReal= val;
                    this.init();
                }
            },
            delayRealEquipe: {
                handler() {
                   this.init();
                }
            },
            timerState: {
                handler() {
                   this.init();
                }
            },
            delayEquipe : {
                handler() {
                    this.init();
                }
            }
        },
        methods: {
            init(val) {
              
                 if (this.timerState=="play") {
                    this.compte_a_rebours();
                    
                 }
                 else {
                     
                     this.calcul_delay();
                     clearTimeout(this.timeout);
                     this.timeout = null;
                     
                 }
            },
            stopTimer() {
               
               // this.calcul_delay();
                if (typeof(this.equipe.timer)!="undefined") {
                    this.equipe.timer.state = 'pause'
                    clearTimeout(this.timeout);
                    this.timeout = null;
                
                    firebase_api.api.getDb().collection("club").doc(this.club.id)
                        .collection("tournois").doc(this.tournoi.id)
                        .collection("parties").doc(this.partie.id)
                        .collection("equipes").doc(this.equipe.id).update({
                            "timer.state": "pause",
                            "timer.delay": this.delayReal
                        })
                }
            },
            setDelay() {
                if (this.equipe.timer.state == 'play') {
                    var ts = (new Date()).getTime();
                    var realTimeStamp = ts - this.$getTimeStamp();
                    
                    var equipeStartTimeStamp = this.delayEquipe;
                
                    var EquipeDate = new Date(equipeStartTimeStamp)
                
                    var realDate = new Date(realTimeStamp);
                
                    var delayDec = ((equipeStartTimeStamp-realTimeStamp) / 1000) / 60;

                    this.delayReal = this.equipe.timer.delay + delayDec;
                
                }
                else
                {
                    this.delayReal = this.equipe.timer.delay;
                    this.icon="pause";
                    this.color = " is-primary";
                }
                if (this.delayReal>2)
                    this.delay = this.delayReal.toFixed(0) + 'mn';
                else  if (this.delayReal<0) {
                    this.delay = "";
                    this.color  = " is-black";
                 
                    this.icon="flag-checkered";
                } 
                else  if (this.delayReal<2) 
                        this.delay = Math.floor(this.delayReal*60)+"s" ;
                
            },
            calcul_delay() {
                var waiting = null;
                 this.setDelay();
                if (this.equipe.timer.state == 'play') {
                    this.icon="clock";
                   
                    if (this.delayReal<0 || this.delay=="0" || this.delay=="") {
                        clearTimeout(this.timeOut);
                        this.timeOut = null;
                        this.delay = "";
                        this.color  = "is-black";
                        this.icon="flag-checkered";
                    }
                    else
                    if (this.delayReal<2) {
                        waiting = 1000;
                        this.color = " is-danger";
                    }
                    else {
                        if (this.delayReal<=5 && this.equipe.timer.state == 'play')
                            this.color = " is-warning";
                        else if (this.equipe.timer.state =="play") {
                            this.color = " is-success";
                        }
                        else {
                        
                            this.color = " is-primary";
                        }
                        waiting = 1000*30;
                    }
                }
                return waiting;
            },
            setTimer() {
               
                this.$emit("setTimer", this.equipe);
            },
            compte_a_rebours() {
                if (typeof(this.equipe)!="undefined") {
                    if (typeof(this.equipe.timer)!="undefined") {
                
                var waiting = this.calcul_delay();
                
                if (this.delay!="0" && this.delay!="" && this.equipe.timer.state =="play" && waiting!=null && !this._isDestroyed) {
                    this.timeOut = setTimeout(
                    ()=>{
                       
                        this.compte_a_rebours()
                    },
                    waiting
                    )
                }
            }
                }
            },
           
        },
       
        async  mounted() {
            this.delayReal= this.timerTournoi;
            if (typeof(this.equipe)!="undefined") {
                    if (typeof(this.equipe.timer)!="undefined") {
                        this.init(this.equipe.timer.state)
                    }
            }
             
        }
 })
</script>